var React = require('react');

function Info (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"22","cy":"22","r":"20.5","stroke":"black","strokeWidth":"3","key":0}),React.createElement("path",{"d":"M20.7298 14.9328H24.4075V11H20.7298V14.9328ZM16.0013 31H29.0013L29 28H24.1637L24.1651 16.6683H16.6614V19.3415H20.9858L20.9845 28H16L16.0013 31Z","fill":"black","key":1})]);
}

Info.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"};

module.exports = Info;

Info.default = Info;
